import { Injectable } from '@angular/core';
import { Incompatibilities } from '../Incompatibilities';
import { Disco } from '../model/Disco';
import { Mother } from '../model/Mother';
import { FuncionCompatilibidadBase } from './FuncionesCompatibilidadBase';
import { IncompatibilitiesType } from '@core/enums/incompatibilities-types.enum';

@Injectable({
  providedIn: 'root',
})
export class FC_MotherDisco extends FuncionCompatilibidadBase<Mother, Disco> {
  funciones = {
    socket: (mother: Mother, disco: Disco): Incompatibilities | null => {
      let tipo = disco.$caracteristicas.tipo;
      return mother.$caracteristicas[tipo == 'M2' ? 'm2' : tipo] ?
          null
        : {
            tipo: IncompatibilitiesType.PRODUCTO,
            incompatibility: `La mother no soporta el tipo de disco ${disco.$caracteristicas.tipo}`,
          };
    },
    interfaz: (mother: Mother, disco: Disco): Incompatibilities | null => {
      const hasNvme = mother.$caracteristicas['m2_nvme'] > 0;
      const hasSata = mother.$caracteristicas['m2_sata'] > 0;
      const diskIsNvme = disco.$caracteristicas.interfaz === 'NVMe';
      const diskIsSata = disco.$caracteristicas.interfaz === 'SATA';
      //m2
      if (disco.$caracteristicas.tipo == 'M2') {
        if (hasNvme && hasSata) {
          return null;
        } else if (hasNvme && diskIsNvme) {
          return null;
        } else if (hasSata && diskIsSata) {
          return null;
        } else {
          //console.log('incompatibles',disco);
          return {
            tipo: IncompatibilitiesType.PRODUCTO,
            incompatibility: `La mother no soporta tipo de m2 ${disco.$caracteristicas.interfaz}`,
          };
        }
      }
    },
  };
}
